import { v4 as uuidv4 } from 'uuid';

const SouthIndianList = [{
    "name": "Masala Dosa",
    "price": [180],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Classic Idli",
    "price": [90],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Sambar Vadai",
    "price": [120],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Rava Upma",
    "price": [110],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Idiyappam",
    "price": [100],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Tomato Uthappam",
    "price": [180],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Rasam Rice",
    "price": [120],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Lemon Rice",
    "price": [90],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Dahi Vada",
    "price": [95],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  },
  {
    "name": "Paneer Dosa",
    "price": [120],
    "isVeg": true,
    "rating": 4.5,
    "type":"South Indian",
    "id": uuidv4()
  }
]

export default SouthIndianList;